function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ApiConstants, ThunkHelper } from 'invision-core';
export var SEARCH_ORDERS_CONSTANTS = {
  BEGIN: 'SEARCH_ORDERS_BEGIN',
  SUCCESS: 'SEARCH_ORDERS_SUCCESS',
  FAILURE: 'SEARCH_ORDERS_FAILURE'
};
var SEARCH_ORDERS_EVENTS = [SEARCH_ORDERS_CONSTANTS.BEGIN, SEARCH_ORDERS_CONSTANTS.SUCCESS, SEARCH_ORDERS_CONSTANTS.FAILURE];
var searchOrdersPromise = function searchOrdersPromise(dispatch, customerId) {
  var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var data = {
    PageSize: filter.pageSize,
    PageNumber: filter.pageNumber
  };
  if (filter.orderStatus && filter.orderStatus.length) {
    data.Statuses = filter.orderStatus.map(function (selectedOrderStatus) {
      return selectedOrderStatus.id;
    });
  }
  if (filter.orderType && filter.orderType.length) {
    data.Types = filter.orderType.map(function (selectedOrderType) {
      return selectedOrderType.id;
    });
  }
  if (filter.Types && filter.Types.length) {
    data.Types = filter.Types;
  }
  if (filter.Statuses && filter.Statuses.length) {
    data.Statuses = filter.Statuses;
  }
  data.ReturnAutomaticOrders = filter.returnAutoOrders;
  data.ReturnMigratedOrders = filter.returnMigratedOrders;
  data.Start = filter.startDate;
  data.End = filter.endDate;
  return ThunkHelper(dispatch, SEARCH_ORDERS_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/SearchOrders',
    data: data,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  }, {
    customerId: customerId
  });
};
export var searchOrders = function searchOrders(customerId, filter) {
  return function (dispatch) {
    return searchOrdersPromise(dispatch, customerId, filter);
  };
};
export var EMPTY_ORDER_HISTORY_LIST = 'EMPTY_ORDER_HISTORY_LIST';
export var emptyOrderHistoryList = function emptyOrderHistoryList() {
  return {
    type: EMPTY_ORDER_HISTORY_LIST
  };
};